let release: Promise<unknown> = Promise.resolve();
export function releasingRuntime(operation: Promise<unknown>): void { release = operation.catch(() => undefined); }
export function waitForRuntimeRelease(): Promise<unknown> { return release; }
